(function () {
  'use strict';

  function initReveal() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mm-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('[data-mm-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function initTestimonials() {
    var testimonials = window.MM_TESTIMONIALS;
    if (!testimonials || !testimonials.length) return;
    var quoteEl = document.getElementById('mm-testi-quote');
    var attribEl = document.getElementById('mm-testi-attrib');
    var dots = document.querySelectorAll('.mm-testi__dot');
    if (!quoteEl || !dots.length) return;
    var idx = 0;

    function setIdx(i) {
      idx = i;
      dots.forEach(function (d, j) {
        d.classList.toggle('mm-testi__dot--active', j === i);
      });
      quoteEl.style.opacity = '0';
      setTimeout(function () {
        quoteEl.innerHTML = testimonials[i].quote;
        if (attribEl) attribEl.textContent = testimonials[i].attrib;
        quoteEl.style.opacity = '1';
      }, 250);
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { setIdx(i); });
    });
    setInterval(function () { setIdx((idx + 1) % testimonials.length); }, 6000);
  }

  function initPersonalize() {
    var input = document.getElementById('mm-p-input');
    var stitch = document.getElementById('mm-p-stitch');
    if (!input || !stitch) return;
    var chips = document.querySelectorAll('.mm-p-fchip');
    var threads = document.querySelectorAll('.mm-p-thread');
    var currentFont = 'italic';

    function render() {
      var v = input.value || 'Your name';
      stitch.textContent = currentFont === 'mono' ? v.toUpperCase() : v;
    }

    input.addEventListener('input', render);

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('mm-p-fchip--on'); });
        chip.classList.add('mm-p-fchip--on');
        currentFont = chip.dataset.f;
        if (currentFont === 'serif') {
          stitch.style.fontFamily = '"DM Serif Display", serif';
          stitch.style.fontSize = '52px';
          stitch.style.letterSpacing = '0';
          stitch.style.fontStyle = 'normal';
        } else if (currentFont === 'mono') {
          stitch.style.fontFamily = '"JetBrains Mono", monospace';
          stitch.style.fontSize = '32px';
          stitch.style.letterSpacing = '0.2em';
          stitch.style.fontStyle = 'normal';
        } else {
          stitch.style.fontFamily = '"Cormorant Garamond", serif';
          stitch.style.fontSize = '52px';
          stitch.style.letterSpacing = '0';
          stitch.style.fontStyle = 'italic';
        }
        render();
      });
    });

    threads.forEach(function (t) {
      t.addEventListener('click', function () {
        threads.forEach(function (x) { x.classList.remove('mm-p-thread--on'); });
        t.classList.add('mm-p-thread--on');
        stitch.style.color = t.dataset.c;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initTestimonials();
    initPersonalize();
  });
})();
